import React from "react";
import Constants from "../../constants/Constants";
import LazyLoad from "react-lazyload";
import ProgressiveImage from "react-progressive-image";
import { Link } from "@reach/router";
import Heart from "../../images/heart-lock.svg";

const ModelLockedUpdate = (props) => {
  const {
    video,
    tags,
    file,
    handleBuyingLockedVideo,
    hasBought,
    modelName,
    dispatch,
  } = props;
  const isAudio = video.archive_type === "audio" ? true : false;
  const goToVideo = () => {
    const height =
      (window.pageYOffset || document.documentElement.scrollTop) -
      (document.documentElement.clientTop || 0);
    setTimeout(() => {
      dispatch({
        type: "scrollTo",
        site: modelName,
        payload: height,
      });
    }, 1500);
  };
  const handleNonActive = (e) => {
    if (!hasBought) {
      handleBuyingLockedVideo({
        ...video,
        file: file.file_name,
        trailer: file.trailer,
      });
      e.preventDefault();
    } else {
      goToVideo();
    }
  };
  return (
    <div className="thumb">
      <Link
        to={`${Constants.MA}video/${video.id}`}
        className="th"
        onClick={(e) => handleNonActive(e)}
        state={{ hasBack: true }}
      >
        <LazyLoad height={374} once>
          <ProgressiveImage
            src={
              hasBought
                ? `https://static.addfriends.com/vip/posters/${file.file_name.replace(
                    ".mp4",
                    ".jpg"
                  )}`
                : isAudio
                ? `http://static.addfriends.com/images/lockedaudio.jpg`
                : `https://static.addfriends.com/vip/posters/${file.file_name.replace(
                    ".mp4",
                    "-lock.jpg"
                  )}`
            }
            placeholder={
              isAudio
                ? `http://static.addfriends.com/images/lockedaudio.jpg`
                : `https://static.addfriends.com/vip/posters/${file.file_name.replace(
                    ".mp4",
                    "-sm.jpg"
                  )}`
            }
          >
            {(src) => <img src={src} alt={`${video.title}`} />}
          </ProgressiveImage>
        </LazyLoad>
        <div className="inform">
          <div className="name">{video.title}</div>
          {!isAudio && <div className="tags">{tags}</div>}
        </div>
      </Link>
      {!hasBought && (
        <div className="lock" onClick={handleNonActive}>
          <div>
            <img src={Heart} alt="Unlock Access" className="unlockme" />
          </div>
          <div style={{ textAlign: "center" }}>
            buy for ${video.price / 100}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelLockedUpdate;
